import type { ProductKind } from 'src/services/mappings/portfolio/portfolio.const'
import type { TailwindColor } from 'src/utils/getColor'
import { PRODUCT_COLORS } from 'src/utils/getColor.const'

export const COLORS_BY_PRODUCT_KIND: Record<ProductKind, TailwindColor> = {
  assurance_vie: PRODUCT_COLORS.cyan,
  contrat_vie_generation: PRODUCT_COLORS.cyan,
  pep_assurance_vie: PRODUCT_COLORS.cyan,
  bons_et_contrats_de_capitalisation: PRODUCT_COLORS.cyan,

  droits_sociaux_pacte_dutreil: PRODUCT_COLORS.lemon,
  droits_sociaux_de_salaries_mandataires: PRODUCT_COLORS.lemon,
  autres_biens_professionnels: PRODUCT_COLORS.lemon,
  entreprise_individuelle: PRODUCT_COLORS.lemon,
  fonds_de_commerce_clienteles: PRODUCT_COLORS.lemon,
  immeubles_professionnels_hors_lmp: PRODUCT_COLORS.lemon,
  droits_sociaux: PRODUCT_COLORS.lemon,
  compte_courant_dassocies: PRODUCT_COLORS.lemon,

  sans_credit_dimpot: PRODUCT_COLORS.default,
  credit_dimpot_acquisition_rp_dans_le_neuf: PRODUCT_COLORS.default,
  credit_dimpot_acquisition_rp_dans_le_vieux: PRODUCT_COLORS.default,
  credit_dimpot_batiment_basse_consommation: PRODUCT_COLORS.default,
  actif_inconnu: PRODUCT_COLORS.default,
  autres_placements_divers: PRODUCT_COLORS.default,
  homme_cle: PRODUCT_COLORS.default,
  capital_differe: PRODUCT_COLORS.default,

  compte_courant: PRODUCT_COLORS.purple,

  credit_a_la_consommation: PRODUCT_COLORS.brown,
  credit_facilites_de_tresorerie: PRODUCT_COLORS.brown,
  credit_dettes_fiscales: PRODUCT_COLORS.brown,
  credit_dettes_familiales: PRODUCT_COLORS.brown,
  credit_autres_dettes_diverses: PRODUCT_COLORS.brown,
  passif_inconnu: PRODUCT_COLORS.default,
  credit_biens_dusage: PRODUCT_COLORS.brown,
  credit_biens_de_rapport: PRODUCT_COLORS.brown,
  credit_scpi_et_sci: PRODUCT_COLORS.brown,
  credit_autres_biens_immobiliers: PRODUCT_COLORS.brown,
  credit_droits_sociaux: PRODUCT_COLORS.brown,
  credit_fonds_de_commerce: PRODUCT_COLORS.brown,
  credit_immobilier_professionnel: PRODUCT_COLORS.brown,
  credit_autres_biens_professionnels: PRODUCT_COLORS.brown,

  compte_sur_livret_csl: PRODUCT_COLORS.blue,
  livret_de_developpement_durable_et_solidaire_ldds: PRODUCT_COLORS.blue,
  livret_a: PRODUCT_COLORS.blue,
  livret_bleus: PRODUCT_COLORS.blue,
  livret_depargne_populaire_lep: PRODUCT_COLORS.blue,
  livret_jeune: PRODUCT_COLORS.blue,
  compte_epargne_logement_cel: PRODUCT_COLORS.blue,
  compte_a_terme: PRODUCT_COLORS.blue,
  bons_de_caisse: PRODUCT_COLORS.blue,
  autres_disponibilites: PRODUCT_COLORS.blue,
  plan_depargne_logement_pel: PRODUCT_COLORS.blue,
  pep_bancaire: PRODUCT_COLORS.blue,
  autres_depots: PRODUCT_COLORS.blue,

  article_39: PRODUCT_COLORS.darkBlue,
  peepei: PRODUCT_COLORS.darkBlue,
  per_individuel: PRODUCT_COLORS.darkBlue,
  per_entreprise_obligatoire: PRODUCT_COLORS.darkBlue,
  percopercoi: PRODUCT_COLORS.darkBlue,
  perp: PRODUCT_COLORS.darkBlue,
  madelin: PRODUCT_COLORS.darkBlue,
  madelin_agricole: PRODUCT_COLORS.darkBlue,
  article_83: PRODUCT_COLORS.darkBlue,
  article_82: PRODUCT_COLORS.darkBlue,
  prefon_retraite: PRODUCT_COLORS.darkBlue,
  retraite_mutualiste_du_combattant: PRODUCT_COLORS.darkBlue,

  immeuble_loue_meuble_lmp: PRODUCT_COLORS.lightGreen,
  parts_de_gfa_gaf_gfv_et_gfr_groupements_fonciers: PRODUCT_COLORS.lightGreen,
  biens_ruraux_loues_a_long_terme: PRODUCT_COLORS.lightGreen,
  residence_principale: PRODUCT_COLORS.lightGreen,
  residence_secondaire: PRODUCT_COLORS.lightGreen,
  terrain: PRODUCT_COLORS.lightGreen,
  autres_biens_dusage: PRODUCT_COLORS.lightGreen,
  terrains_agricoles: PRODUCT_COLORS.lightGreen,
  parts_de_groupements_forestiers: PRODUCT_COLORS.lightGreen,
  bois_et_forets: PRODUCT_COLORS.lightGreen,
  parts_de_societes_depargne_forestiere: PRODUCT_COLORS.lightGreen,
  immeuble_locatif_loue_nu: PRODUCT_COLORS.lightGreen,
  immeuble_loue_meuble_lmnp: PRODUCT_COLORS.lightGreen,
  lmnp_bouvard: PRODUCT_COLORS.lightGreen,
  parts_de_sci: PRODUCT_COLORS.lightGreen,
  autres_immeubles_de_rapport: PRODUCT_COLORS.lightGreen,

  meuble_meublant: PRODUCT_COLORS.beige,
  objets_dart_et_antiquites: PRODUCT_COLORS.beige,

  pea: PRODUCT_COLORS.orange,
  pea_pme: PRODUCT_COLORS.orange,
  compte_titres: PRODUCT_COLORS.orange,

  temporaire_deces: PRODUCT_COLORS.pink,
  vie_entiere: PRODUCT_COLORS.pink,
  contrat_prevoyance_individuelle: PRODUCT_COLORS.pink,
  convention_obseques: PRODUCT_COLORS.pink,

  parts_de_scpi: PRODUCT_COLORS.green,
  sicav_fcp_actions: PRODUCT_COLORS.green,
  sicav_fcp_obligations: PRODUCT_COLORS.green,
  sicav_fcp_monetaire: PRODUCT_COLORS.green,
  actions_francaises_et_europeennes: PRODUCT_COLORS.green,
  actions_etrangeres: PRODUCT_COLORS.green,
  obligations: PRODUCT_COLORS.green,
  stock_options: PRODUCT_COLORS.green,
  sofica: PRODUCT_COLORS.green,
  fcpi: PRODUCT_COLORS.green,
  fcpr: PRODUCT_COLORS.green,
  fip: PRODUCT_COLORS.green,
  fip_corse: PRODUCT_COLORS.green,
  parts_de_holding: PRODUCT_COLORS.green,
  capital_de_pmetpe: PRODUCT_COLORS.green,
  autres_droits_sociaux: PRODUCT_COLORS.green,
  autres_valeurs_mobilieres: PRODUCT_COLORS.green,
}
